document.addEventListener("DOMContentLoaded", () => {
  const sampleSections = document.querySelectorAll(".ecs-sample-service");

  if (!sampleSections.length) {
    return;
  }

  sampleSections.forEach((sectionElement) => {
    const sectionId = sectionElement.getAttribute("data-section-id");
    const mainImage = sectionElement.querySelector(`#ecs-main-image-${sectionId}`);
    const thumbButtons = sectionElement.querySelectorAll(".ecs-sample__thumb-btn");
    const emblaNode = sectionElement.querySelector(".ecs-sample__embla");

    if (mainImage && thumbButtons.length > 0) {
      thumbButtons.forEach((btn) => {
        btn.addEventListener("click", function () {
          thumbButtons.forEach(b => b.classList.remove("is-active"));
          this.classList.add("is-active");

          mainImage.style.opacity = 0;
          
          setTimeout(() => {
            mainImage.src = this.getAttribute("data-full-src");

            if (this.getAttribute("data-srcset")) {
              mainImage.srcset = this.getAttribute("data-srcset");
            }
            mainImage.style.opacity = 1;
          }, 200);
        });
      });
    }

    if (emblaNode) {
      const viewportNode = emblaNode.querySelector(".embla__viewport");

      if (viewportNode) {
        const embla = EmblaCarousel(viewportNode, {
          align: "start",
          containScroll: "trimSnaps",
          dragFree: true
        });
      }
    }
  });
});